import { render, staticRenderFns } from "./PlanDetails.vue?vue&type=template&id=10639a0f&scoped=true"
import script from "./PlanDetails.vue?vue&type=script&lang=js"
export * from "./PlanDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10639a0f",
  null
  
)

export default component.exports